// src/services/s3.js
import client from "./client";

/**
 * Pega do back-end uma signed URL para upload de imagem.
 *
 * @param {string} key         — caminho + nome do arquivo no bucket (ex: "events_images/162345.png")
 * @param {string} contentType — tipo MIME (ex: "image/jpeg")
 * @returns {Promise<string>}  — URL assinada válida para PUT no S3
 */
export async function getImageUploadUrl(key, contentType) {
  const { data } = await client.get("/signed-url", {
    params: { key, contentType },
  });
  return data.url;
}
